// extracted by mini-css-extract-plugin
module.exports = {"CheckboxButton":"CheckboxButton_CheckboxButton__sovAG"};